/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';

/**
 * 
 * @export
 * @interface CustomRowSelectionChoice
 */
export interface CustomRowSelectionChoice {
    /**
     * 
     * @type {string}
     * @memberof CustomRowSelectionChoice
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof CustomRowSelectionChoice
     */
    id: string;
    /**
     * 
     * @type {Command}
     * @memberof CustomRowSelectionChoice
     */
    postCustomRowSelectionChoiceCommand?: Command;
}

/**
 * Check if a given object implements the CustomRowSelectionChoice interface.
 */
export function instanceOfCustomRowSelectionChoice(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function CustomRowSelectionChoiceFromJSON(json: any): CustomRowSelectionChoice {
    return CustomRowSelectionChoiceFromJSONTyped(json, false);
}

export function CustomRowSelectionChoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomRowSelectionChoice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'id': json['id'],
        'postCustomRowSelectionChoiceCommand': !exists(json, 'postCustomRowSelectionChoiceCommand') ? undefined : CommandFromJSON(json['postCustomRowSelectionChoiceCommand']),
    };
}

export function CustomRowSelectionChoiceToJSON(value?: CustomRowSelectionChoice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'id': value.id,
        'postCustomRowSelectionChoiceCommand': CommandToJSON(value.postCustomRowSelectionChoiceCommand),
    };
}

